import React, { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import "../../styles/sidebar/sidebar.css";
import "../../styles/dashboard/dashboard.css";
import Header from "../../components/header/Header";
import InfoCard from "../../components/cards/InfoCard";
import ProgressBar from "../../components/progressbar/ProgressBar";
import MapComponent from "../../components/maps/MapComponent";
import "../../styles/cards/card.css";
import axios from "axios";
import Cookies from "js-cookie";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const AdminDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [indexRecordStats, setIndexRecordStats] = useState({
    totalIndexed: 0,
    approved: 0,
  });
  const [loadingCards, setLoadingCards] = useState(true);
  const [scannedRecordStats, setScannedRecordStats] = useState({
    totalScanned: 0,
    totalBooks: 0,
    approvedBooks: 0,
    approved: 0,
  });
  const [sectors, setSectors] = useState([]);
  const totalBooks = process.env.REACT_APP_TOTAL_BOOKS;
  const totalRecords = process.env.REACT_APP_TOTAL_RECORDS;

  useEffect(() => {
    // Fetch indexed records stats

    const fetchIndexedRecordsStats = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(
          `${baseUrl}/api/index/indexed-records/total-stats`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setIndexRecordStats(res.data);
      } catch (error) {
        setError("Failed to load index records total stats");
      } finally {
        setLoadingCards(false);
      }
    };

    const fetchScannedRecordsStats = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(
          `${baseUrl}/api/scanned/scanned-records/total-stats`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setScannedRecordStats(res.data);
      } catch (error) {
        setError("Failed to load scanned records total stats");
      } finally {
        setLoadingCards(false);
      }
    };

    fetchIndexedRecordsStats();
    fetchScannedRecordsStats();
  }, [baseUrl]);


  useEffect(() => {
    const fetchLatestScannedSites = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(
          `${baseUrl}/api/sites/latest-sites/approved`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setSectors(res.data);
      } catch (err) {
        setError("Failed to load latest scanned sites");
      } finally {
        setLoading(false);
      }
    };

    fetchLatestScannedSites();
  }, [baseUrl]);

  const renderSkeletonCards = () => {
    return Array(3)
      .fill()
      .map((_, index) => (
        <div key={index} className="card" style={{ minWidth: "300px" }}>
          <div className="card-header">
            <Skeleton width={250} height={12} />
            <Skeleton width={60} height={40} />
          </div>
          <div className="line"></div>
          <div className="card-content">
            <div className="progress-bar-container">
              <Skeleton width="100%" height={10} />
              <Skeleton width={80} height={12} style={{ marginTop: "11px" }} />
            </div>
          </div>
        </div>
      ));
  };

  return (
    <>
      <div className="dashboard-container">
        <Sidebar role="admin" />
        <div className="main-content">
          <Header />
          <div className="dashboard-content">
            <div className="dashboard-cards">
              {loadingCards ? (
                renderSkeletonCards()
              ) : (
                <>
                  <InfoCard
                    value={`${indexRecordStats.approved}/${totalRecords}`}
                    title="INDEXED RECORDS"
                    fetchDetails={() =>
                      axios.get(`${baseUrl}/api/index/indexed-records/stats/details`, {
                        headers: { Authorization: `Bearer ${Cookies.get("token")}` },
                      })
                    }
                  />
                  <InfoCard
                    value={`${scannedRecordStats.approvedBooks}/${totalBooks}`}
                    title="SCANNED BOOKS"
                    fetchDetails={() =>
                      axios.get(`${baseUrl}/api/scanned/scanned-records/stats/details`, {
                        headers: { Authorization: `Bearer ${Cookies.get("token")}` },
                      })
                    }
                  />
                  <InfoCard
                    value={`${scannedRecordStats.approved}/${totalRecords}`}
                    title="SCANNED RECORDS"
                    fetchDetails={() =>
                      axios.get(`${baseUrl}/api/scanned/scanned-records/stats/details`, {
                        headers: { Authorization: `Bearer ${Cookies.get("token")}` },
                      })
                    }
                  />
                </>
              )}
            </div>

            <div className="demographic-data">
              <div className="title">Situation Map</div>
              <div className="content">
                <MapComponent />
                <div className="sectors">
                  <div className="title">Sectors with the highest records</div>
                  <div className="sector-container">
                    {sectors.map((sector, index) => (
                      <ProgressBar
                        key={index}
                        label={sector.label}
                        value={sector.value}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
